import type { Conversation, ConversationSummary } from '@/types/conversation';

/**
 * Generate a title for a conversation
 * In v2, conversations no longer have embedded messages,
 * so we use the title field or fallback to ID
 */
export function generateConversationTitle(
  conversation: Conversation | ConversationSummary
): string {
  // Use title if available
  if (conversation.title) {
    return conversation.title;
  }

  // Fallback to truncated ID
  return `Conversazione ${conversation.id.substring(0, 8)}...`;
}

/**
 * Format a timestamp to a relative time string
 * @param isoString ISO 8601 UTC string
 */
export function formatRelativeTime(isoString: string): string {
  const timestamp = new Date(isoString).getTime();
  const now = Date.now();
  const diff = now - timestamp;

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return 'Adesso';
  } else if (minutes < 60) {
    return `${minutes}m fa`;
  } else if (hours < 24) {
    return `${hours}h fa`;
  } else if (days < 7) {
    return `${days}g fa`;
  } else {
    return new Date(timestamp).toLocaleDateString('it-IT');
  }
}
